import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import Routes from './routes';
import { InitialFetchProvider } from './core/context/initialFetchContext';
import { NavBarDatahProvider } from './core/context/navBarContext';
import { FiltersCardsProvider } from 'core/context/filtersCardsContext';
import { FiltersSidebarProvider } from 'core/context/filtersSidebarContext';
import ConsentBanner from './components/ConsentBanner'; // Importar el banner de consentimiento

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children;
    }
}

const ScrollToTopWithRouter = withRouter(ScrollToTop);

class Root extends Component {
    render() {
        return (
            <Router basename="/">
                <ScrollToTopWithRouter>
                    <div>
                        <Routes />
                    </div>
                </ScrollToTopWithRouter>
            </Router>
        )
    }
}

const App = () => (
    <FiltersSidebarProvider>
        <FiltersCardsProvider>
            <NavBarDatahProvider>
                <InitialFetchProvider>
                    <ConsentBanner /> {/* Agregar el banner de consentimiento */}
                    <Root />
                </InitialFetchProvider>
            </NavBarDatahProvider>
        </FiltersCardsProvider>
    </FiltersSidebarProvider>
);

ReactDOM.render(<App />, document.getElementById('quarter'));